import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  content: {
    zIndex: 9,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  stage: {
    // backdropFilter: 'blur(10px)',
    zIndex: 9,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  pictures: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  picture: {
    zIndex: 9,
    maxHeight: '50vh',
    borderRadius: theme.shape.borderRadius * 2,
    boxShadow: theme.shadows[12],
    transition: 'all 150ms ease-in-out',
  },
  renderBar: {
    zIndex: 10,
    position: 'relative',
    boxShadow: theme.shadows[3],
    backgroundColor: theme.palette.background.paper2,
    display: 'flex',
    padding: 15,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footer: {
    zIndex: 9,
    minHeight: 140,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    overflowX: 'auto',
    scrollBehavior: 'smooth',
    backgroundColor: theme.palette.background.default,
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
      height: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
  selectButton: {
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 100,
    width: 100,
    height: 100,
    backgroundColor: 'rgba(255,255,255,1)',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    cursor: 'pointer',
    opacity: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.9,
    transition: 'all 150ms ease-in-out',
    '&:hover': {
      opacity: 1,
    },
  },
  spacer: {
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 15,
    width: 15,
    height: 15,
  },
  thumbAlign: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  thumbnail: {
    zIndex: 9,
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 100,
    width: 100,
    height: 100,
    backgroundColor: 'rgba(255,255,255,1)',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    cursor: 'pointer',
    opacity: 0.5,
    transition: 'all 150ms ease-in-out',
    '&:hover': {
      boxShadow: theme.shadows[6],
      opacity: 1,
      transform: `scale(1.1)`,
    },
  },
  thumbnailActive: {
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 100,
    width: 100,
    height: 100,
    backgroundColor: 'rgba(255,255,255,1)',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    cursor: 'pointer',
    opacity: 1,
    transform: `scale(1.1)`,
    transition: 'all 150ms ease-in-out',
    '&:hover': {
      boxShadow: theme.shadows[6],
      opacity: 1,
      transform: `scale(1.1)`,
    },
  },
  initial: {
    zIndex: 9,
    filter: 'blur(1px) brightness(.7)',
    opacity: 0.9,
  },
  iconContent: {
    zIndex: 9,
    display: 'block',
    position: 'absolute',
  },
  icon: {
    zIndex: 9,
    fontSize: 50,
    color: theme.palette.status[3],
    cursor: 'pointer',
    opacity: 0.9,
  },
  emptySpace: {
    zIndex: 9,
    width: '100%',
    display: 'flex',
    paddingTop: 150,
    paddingBottom: 150,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  emojiPanel: {
    zIndex: 10000,
    position: 'absolute',
    right: 0,
    bottom: 135,
  },
}))

export default useStyles
